import React from 'react'

const JS_Essentials_Assignment_1 = () => {
  return (
    <div>
      <h1>JS EssentialsAssignment 1</h1>
    </div>
  )
}

export default JS_Essentials_Assignment_1
